import type { TodoId } from "@common/types/todo";
import type { CommandPaletteStates } from "@web/src/app/components/global-command/options/global-command-options";
import type { HomeModalKinds } from "@web/src/app/components/modals/home-modals";
import type { HighlightableId } from "@web/src/app/use-cases/todo-highlight";
import EventEmitter from "eventemitter3";

export type WebEventTypes = {
  WEB_FOCUS_TODO: (highlightableId: HighlightableId | null) => void;
  WEB_BLUR_TODO: () => void;
  WEB_TODO_ON_BLUR: () => void;
  WEB_TODO_ON_CARET_MOVE: (e: { currentTarget: { selectionStart: number | null; value: string } }) => void;
  WEB_ON_MOVED_TODO: (todoId: TodoId) => void;
  WEB_ON_HIGHLIGHT_CHANGED: (highlightId: string) => void;
  WEB_SET_GLOBAL_COMMAND_OPEN: (open: boolean, defaultState?: CommandPaletteStates) => void;
  WEB_REHIGHLIGHT_NEXT_FRAME: () => void; // anticipative: will select another highlightable in a similar position on screen
  WEB_SHOW_MODAL: (modal: HomeModalKinds) => void;
  TOGGLE_FOCUS_MODE: () => void;
};

export const WebEvents = new EventEmitter<WebEventTypes>();
